import { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { CloseSquare, TickCircle } from "iconsax-react";
import { Dialog, DialogContent, DialogTitle, IconButton, Box, Button, DialogActions } from "@mui/material";
import styles from './edit-card.module.scss';
import UploadImgModal from "../../my-data/category/upload-img-modal";

const EditImageModal = observer(({ show, setShow, uiStore, selected, cardId }) => {
    const { images } = uiStore;
    const [selectedImg, setSelectedImg] = useState(selected);

    useEffect(() => {
        uiStore.fetchImages();
    }, [show, uiStore])

    const confirm = async () => {
        await uiStore.selectImg(selectedImg, cardId);
        setShow(false);
    }

    return (
        <Dialog open={show} maxWidth='md' fullWidth onClose={() => setShow(false)}
            PaperProps={{ sx: { padding: '20px' }, variant: 'round' }}
        >
            <DialogTitle>
                Edit Card Image
                <IconButton
                    aria-label="close"
                    onClick={() => setShow(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseSquare
                        size="30"
                        variant="Bulk"
                    />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                    <UploadImgModal uiStore={uiStore} />
                    {images?.map(img => (
                        <Button
                            key={img._id}
                            className={selectedImg === img.imgUrl ? styles.imgBlockSelected : styles.imgBlock}
                            onClick={() => setSelectedImg(img.imgUrl)}
                            sx={{ ml: '20px' }}
                        >
                            {selectedImg === img.imgUrl &&
                                <TickCircle
                                    size="24"
                                    variant="Bulk"
                                    className={styles.selectImgIcon}
                                />
                            }
                            <img src={img.imgUrl} alt='person' />
                        </Button>
                    ))}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setShow(false)} variant="contained" color="lightblue">
                    Cancel
                </Button>
                <Button onClick={confirm} variant="contained" color="primary">
                    Select
                </Button>
            </DialogActions>
        </Dialog>
    );
});

export default EditImageModal;
